const vatStatuses = (["notRegistered", "registered"] as const).map((e) => e);
export type VatStatuses = (typeof vatStatuses)[0];

export class VatStatus {
  constructor({ name }: { name: VatStatuses }) {
    this.name = name;
  }

  name: VatStatuses;

  static def: VatStatus = new VatStatus({ name: "registered" });

  static fromString(str: string): VatStatus {
    const lowerStr = str.replace(/[_-]/g, "").toLowerCase();
    const name = vatStatuses.find((e) => e.toLowerCase() === lowerStr);
    if (name) {
      return new VatStatus({ name });
    }
    throw new Error("Invalid type of the VAT status.");
  }

  static isValidString(str?: string): boolean {
    const lowerStr = str?.replace(/[_-]/g, "")?.toLowerCase();
    const name = vatStatuses.find((e) => e.toLowerCase() === lowerStr);
    return !!name;
  }

  toString(): string {
    return this.name;
  }
}
